import type { TMessengerErpLayoutMode } from '@xometry/ui';

export const ERP_MESSENGER_LAYOUT_STORAGE_KEY = 'erpMessengerLayoutMode';

export const readErpMessengerLayoutModeFromStorage = (): TMessengerErpLayoutMode => {
  try {
    const raw = localStorage.getItem(ERP_MESSENGER_LAYOUT_STORAGE_KEY);

    if (raw === 'compact' || raw === 'classic') return raw;
  } catch (e) {
    console.error(e);
  }

  return 'classic';
};

export const writeErpMessengerLayoutModeToStorage = (mode: TMessengerErpLayoutMode) => {
  try {
    localStorage.setItem(ERP_MESSENGER_LAYOUT_STORAGE_KEY, mode);
  } catch (e) {
    console.error(e);
  }
};
